<template>
 <v-container class=" pa-12 pb-12 text-center" :class="classes">
    <v-progress-circular
    :size="70"
    color="black"
    style="padding-top:10em;padding-bottom:10em;margin-top:3em;margin-bottom:3em;"
    indeterminate
  ></v-progress-circular>
</v-container>


</template>

<script>
  export default {
    props:{
      classes:{
        type:String
      },
      text:{
        type:String
      }
    },
    data: () => ({
    }),
  }
</script>

<style lang="css" scoped>

</style>